import { showNotification } from 'features/notifications'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import routes from 'routes'
import { _ } from 'utils'
import { isAuthenticatedSelector, logout } from '../authSlice'
import { eventPreviewSelector } from '../eventPreviewSlice'

const Logout = () => {
    const eventPreview = useSelector(eventPreviewSelector)
    const dispatch = useDispatch()
    const history = useHistory()
    const isAuthenticated = useSelector(isAuthenticatedSelector)
    const isExpiredToken = new URLSearchParams(window.location.search).get('token-expired')

    React.useEffect(() => {
        if (isExpiredToken === 'true') {
            dispatch(showNotification({
                type: 'info',
                body: _('auth.logged_out.token_is_expired'),
                displayDuration: 7000,
                id: 888,
            }))
        }
    }, [dispatch, isExpiredToken])

    React.useEffect(() => {
        if (eventPreview?.slug) {
            dispatch(logout())
            history.push(routes.enterEvent.getPath({ eventSlug: eventPreview?.slug }))
            return
        }

        if (isAuthenticated) {
            dispatch(logout())
            history.push('/')
        }
    }, [dispatch, eventPreview, history, isAuthenticated])
    return null
}

export default Logout
